'use client';

import React, { useEffect, useRef, useState } from 'react';

interface ScoreDisplayProps {
  score: number;
  scoreKey: number;
}

export default function ScoreDisplay({ score, scoreKey }: ScoreDisplayProps) {
  const [displayScore, setDisplayScore] = useState(score);
  const [bumping, setBumping] = useState(false);
  const prevScore = useRef(score);
  const rafRef = useRef<number | null>(null);

  useEffect(() => {
    if (score === prevScore.current) return;
    setBumping(true);
    const start = prevScore.current;
    const end = score;
    const duration = 300;
    const startTime = performance.now();

    const animate = (now: number) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplayScore(Math.round(start + (end - start) * eased));
      if (progress < 1) {
        rafRef.current = requestAnimationFrame(animate);
      } else {
        prevScore.current = end;
        setTimeout(() => setBumping(false), 100);
      }
    };

    if (rafRef.current) cancelAnimationFrame(rafRef.current);
    rafRef.current = requestAnimationFrame(animate);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [score, scoreKey]);

  return (
    <p
      className={`font-mono-game text-2xl font-bold leading-none ${bumping ? 'score-bump' : ''}`}
      style={{ color: '#ffd60a' }}
    >
      {displayScore.toLocaleString()}
    </p>
  );
}